<template>
  <nuxt-img
    :src="imageUrl"
    :alt="alt"
    :style="{ 'min-height': minHeight }"
  />
</template>

<script setup lang="ts">
const props = defineProps({
  src: {
    type: String,
    required: true,
  },
  alt: {
    type: String,
    required: true,
  },
  minHeight: {
    type: String,
    required: true,
  },
  localize: {
    type: Boolean,
    default: false,
  },
});

const { locale } = useI18n();

const imageUrl = computed(() => {
  if (!props.localize) {
    return props.src;
  }

  switch (locale.value) {
    case 'es':
      return `/images/ES/ES_${props.src}`;
    case 'es-mx':
      return `/images/MX/MX_${props.src}`;
    case 'de':
      return `/images/DE/DE_${props.src}`;
    case 'pt':
      return `/images/PT/PT_${props.src}`;
    case 'pt-br':
      return `/images/BR/BR_${props.src}`;
    case 'fr':
      return `/images/FR/FR_${props.src}`;
    case 'it':
      return `/images/IT/IT_${props.src}`;
    case 'en':
    default:
      return `/images/EN/EN_${props.src}`;
  }
});
</script>
